import { render, staticRenderFns } from "./BuscaAnoNivelEtapaDisciplina.vue?vue&type=template&id=799edae2&"
import script from "./BuscaAnoNivelEtapaDisciplina.vue?vue&type=script&lang=js&"
export * from "./BuscaAnoNivelEtapaDisciplina.vue?vue&type=script&lang=js&"
import style0 from "./BuscaAnoNivelEtapaDisciplina.vue?vue&type=style&index=0&id=799edae2&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports